interface CategoryOption {
  category: string;
}
interface PageOption {
  page?: string;
}

interface MandatoryTrackEventOptions {
  action: string;
  label: string;
}

type TrackEventArg = MandatoryTrackEventOptions &
  PageOption &
  Partial<CategoryOption>;

type TrackWebVitals = (params: {
  category: string;
  label: string;
  page: string;
}) => {
  handler: (metric: {
    delta: number;
    name?: string;
    id?: string;
    value?: number;
  }) => void;
};
type TrackSurvey = (event: string) => void;
type TrackFireEvent = (category: string, key?: string, value?: string) => void;
type TrackPage = (page: string, options?: Record<string, unknown>) => void;
type TrackEvent<ArgType> = (arg: ArgType) => void;

export interface Piwik {
  push: (...args: Array<string>) => void;
}

interface GaGetAllFunction {
  (): Array<{ get: (arg: string) => string }>;
}

export interface GaFunction {
  (...args: Array<string>): void;
  getAll?: GaGetAllFunction;
}

declare global {
  interface Window {
    ga?: GaFunction;
    _paq?: Piwik;
  }
}

export interface ThirdPartyTrackingAgent {
  /**
   * @deprecated in favor of using useTracking().trackQualtrics()
   */
  trackSurvey: TrackSurvey;
  /**
   * @deprecated in favor of using useTrackPage().trackGAPage()
   */
  trackPage: TrackPage;
  setCustomDimension: (dimension: string, value: string) => void;
  trackEvent: TrackEvent<TrackEventArg>;
  trackFireEvent: TrackFireEvent;
  trackQualtrics: TrackSurvey;
  trackWebVitals: TrackWebVitals;
}

export const funnelDecorator = (
  funnel: string,
  thirdPartyTrackingAgent: ThirdPartyTrackingAgent,
): ThirdPartyTrackingAgent => {
  const prefix = !funnel || funnel === "flights" ? "" : funnel + "_";
  return {
    ...thirdPartyTrackingAgent,
    trackEvent: ({ label, category, ...restOptions }) => {
      return thirdPartyTrackingAgent.trackEvent({
        ...restOptions,
        label: prefix + label,
        category: prefix + category,
      });
    },
  };
};
